import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Form, Button, ListGroup } from 'react-bootstrap';
import Select from 'react-select';
import { MultiSelect } from "react-multi-select-component";
import customerImg from '../../../assets/images/CustomerManagement/customer-img.svg';
import Main from '../../Main';
import '../../../assets/css/userprofile.scss'
import { SBSaveUpdateBtn } from '../../Buttons/Buttons';
import Download from '../Download/Download';
import calendar from '../../../assets/images/Dashboard/calendar-icon.svg';
import DatePicker from "react-datepicker";
import SaveCustomeViewModal from './SetPasswordModal';
import SetPasswordModal from './SetPasswordModal';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadCountryCodeDropdownData, loadProfileDetailsData, loadTimeZoneDropdownData, postUpdateProfileSettingsDatas } from '../../../redux/action';
import moment from 'moment';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';

const UserProfileForm = ({ setSessionExpired, setErrorMessage }) => {

    let dispatch = useDispatch();

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const UserID = signInDetails ? signInDetails[0].UserID : null
    const SignInType = signInDetails ? signInDetails[0].SignInType : null
    // const { singleUserData } = useSelector((state) => state.data);
    const { getCountryCodeDropdownData } = useSelector((state) => state.data);
    const { getProfileDetails } = useSelector((state) => state.data);
    const { getTimeZoneDropdown } = useSelector((state) => state.data);

    const emailNotificationOptions = [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' },
    ];

    const dateFormatOptions = [
        { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
        { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
        { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
        { value: 'YYYY/MM/DD', label: 'YYYY/MM/DD' },
        { value: 'DD-MMM-YYYY', label: 'DD-MMM-YYYY' },
        { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
        { value: 'YYYY.MM.DD', label: 'YYYY.MM.DD' },
        { value: 'DD Mon YYYY', label: 'DD Mon YYYY' },
        { value: 'YYYYMMDD', label: 'YYYYMMDD' },
        { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY' },
    ];
    const timeFormatOptions = [
        { value: '12-hour', label: '12-Hour Format (HH:MM AM/PM)' },
        { value: '24-hour', label: '24-Hour Format (HH:MM)' },
        { value: 'ISO', label: 'ISO 8601 Format (YYYY-MM-DDTHH:MM:SSZ)' },
    ];

    let AddedByID = null;

    // Check the SignInType and assign appropriate IDs
    if (signInDetails[0]?.SignInType === "SuperAdmin") {
        // CustomerID = signInDetails[0]?.CompanyID; // Assuming SuperAdminID is available in SignInDetails
        AddedByID = signInDetails[0]?.SuperAdminID;; // Assuming SuperAdminID is available in SignInDetails
    } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
        AddedByID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
    } else if (signInDetails[0]?.SignInType === "User") {
        AddedByID = signInDetails[0]?.UserID; // Use UserID for User type
    }

    const [userData, setUserData] = useState({
        Image: "",
        FileName: "",
        IsFileUpdated: false, // Default value is false
        UserCode: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        EmailID: "",
        CountryCodeID: null,
        Phone: "",
        WorkAddress: "",
        ZipCode: "",
        DOB: "",
        SecondaryPhoneCountryCodeID: null,
        SecondaryPhone: "",
        DesignationID: "",
        DepartmentID: "",
        DOJ: "",
        TotalExperience: "",
        ProbationPeriod: "",
        ReportingToID: "",
        HomeAddress: "",
        DateFormat: "",
        TimeFormat: "",
        TimeZone: "",
        IsToSendEmailNotifications: null,
    });

    const [imgChange, setImgChange] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // useEffect(() => {
    //     if (UserID)
    //         dispatch(loadSingleUserManagementData(UserID))
    // }, [UserID]);

    useEffect(() => {
        dispatch(loadCountryCodeDropdownData());
        dispatch(loadTimeZoneDropdownData());
    }, [])

    useEffect(() => {
        profileData();
    }, [])

    const profileData = () => {
        dispatch(loadProfileDetailsData(setSessionExpired, setErrorMessage));
    }

    const handleChange = (field, value) => {
        setUserData((prev) => ({ ...prev, [field]: value }));
        // setErrors((prev) => ({ ...prev, [field]: null }));  // Clear error when user starts typing
    };

    // Handle the country code select change
    const handleChangeCountryCode = (selectedOption) => {
        handleChange("CountryCodeID", selectedOption.value);
    };

    // Handle emergency phone code select change
    const handleChangeEmergencyCode = (selectedOption) => {
        handleChange("SecondaryPhoneCountryCodeID", selectedOption.value);
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const fileInputRef = useRef(null);
    const [selectedImg, setSelectedImg] = useState(null); // State for the selected image

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the file selected by the user
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                // The full base64 string includes the 'data:image/png;base64,' part
                const base64String = reader.result;

                // Get the filename from the file object
                const fileName = file.name;  // Get the file name

                // Set the fileName as prefix, so that it contains only the file name
                handleChange("FileName", fileName);  // Send the file name to your backend

                // Store the full base64 data in the File parameter (excluding the prefix)
                const base64Data = base64String.split(',')[1];  // Extract the actual base64 data part
                handleChange("Image", base64Data);  // Save the base64 data in the File field

                // Update the state to display the image preview using full base64 string
                setSelectedImg(base64String);  // Display the image preview in the UI
                setImgChange(true);
            };
            reader.readAsDataURL(file);  // Convert the image to base64 format
        }
    };

    useEffect(() => {
        if (getProfileDetails && getProfileDetails.length > 0) {
            const user = getProfileDetails[0];  // Get the first user from the array
            setUserData({
                UserID: user.UserID,
                FileName: user.FileName || '',
                FilePath: user.FilePath || '',
                IsFileUpdated: false,  // Default to false
                UserCode: user.UserCode || '',
                CustomerID: user.CustomerID || '',
                FirstName: user.FirstName || '',
                MiddleName: user.MiddleName || '',
                LastName: user.LastName || '',
                EmailID: user.EmailID || '',
                CountryCodeID: user.CountryCodeID || '',
                Phone: user.Phone || '',
                WorkAddress: user.WorkAddress || '',
                ZipCode: user.ZipCode || '',
                HomeAddress: user.HomeAddress || '',
                DOB: user.DOB ? moment(user.DOB).toDate() : '',
                SecondaryPhoneCountryCodeID: user.SecondaryPhoneCountryCodeID || '',
                SecondaryPhone: user.SecondaryPhone || '',
                DesignationID: user.DesignationID || '',
                DepartmentID: user.DepartmentID || '',
                DepartmentName: user.DepartmentName || '',
                AssignedRoles: user.AssignedRoles || '',
                JobTitle: user.JobTitle || '',
                DOJ: user.DOJ ? moment(user.DOJ).toDate() : '',
                TotalExperience: user.TotalExperience || '',
                ProbationPeriod: user.ProbationPeriod || '',
                ReportingToID: user.ReportingToID || '',
                StatusID: user.StatusID || '',
                DateFormat: user.DateFormat || '',
                TimeFormat: user.TimeFormat || '',
                TimeZone: user.TimeZone || '',
                IsToSendEmailNotifications: user.IsToSendEmailNotifications || '',
            });
            // Set the image if it exists
            if (user.FilePath) {
                setSelectedImg(user.FilePath);  // Use the FilePath from the API for the preview
            }
        }
    }, [getProfileDetails]);

    // Handle the date picker change for DOB, DOJ, etc.
    const handleDateChange = (field, date) => {
        handleChange(field, date);
    };

    const AddProfileData = (e) => {
        e.preventDefault();

        const updatedUserData = {
            ...userData,
            SigninType: SignInType,  // Ensure these fields are included
            AddedByID: ADDED_BY_ID,
            IsFileUpdated: imgChange
        };
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(updatedUserData),
        };
        dispatch(postUpdateProfileSettingsDatas(requestOption, imgChange, setImgChange, profileData));
    }


    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Profile Details"
                        onBackClick={handleBack}
                    />
                </div>
                <Row className="user-profile-form-container">
                    <Col md={3} className="user-profile-form-first-col">
                        <img src={
                            selectedImg // Check if an image has been selected
                                ? selectedImg // Display the selected image (base64 string or URL)
                                : userData?.FilePath // Check if there is an image from the server
                                    ? userData?.FilePath.includes('http') // If it's a URL, display it
                                        ? userData?.FilePath // If it's a valid URL, display it
                                        : `data:image/png;base64,${userData?.FilePath}` // If it's base64, prepend the MIME type
                                    : customerImg // Fallback to customerImg if no selected image or server image
                        }
                            alt="Profile"
                            className="img-fluid rounded-circle mb-3"
                        />
                        <ListGroup variant="flush" className='user-profile-list-items'>
                            <ListGroup.Item><p>ID</p><p>{userData?.UserID || "NA"}</p></ListGroup.Item>
                            <ListGroup.Item><p>Name</p><p>{userData?.FirstName || "NA"} {userData?.MiddleName} {userData?.LastName}</p></ListGroup.Item>
                            <ListGroup.Item><p>Email ID</p><p>{userData?.EmailID || "NA"}</p></ListGroup.Item>
                            <ListGroup.Item><p>Role</p><p>{userData?.AssignedRoles || "NA"}</p></ListGroup.Item>
                            <ListGroup.Item><p>Department</p><p>{userData?.DepartmentName || "NA"}</p></ListGroup.Item>
                            <ListGroup.Item><p>Contact</p><p>{userData?.Phone || "NA"}</p></ListGroup.Item>
                            <ListGroup.Item><p>Address</p><p>{userData?.HomeAddress || "NA"}</p></ListGroup.Item>
                        </ListGroup>
                    </Col>

                    <Col md={8} className='user-profile-form-second-col'>
                        <h6>Add User Profile</h6>
                        <hr />
                        <Row className='user-profile-form-row'>
                            <Col className='text-center mb-4 user-profile-form-col'>
                                <div>
                                    <img
                                        // src={selectedImg || customerImg} 
                                        src={
                                            selectedImg // Check if an image has been selected
                                                ? selectedImg // Display the selected image (base64 string or URL)
                                                : userData?.FilePath // Check if there is an image from the server
                                                    ? userData?.FilePath.includes('http') // If it's a URL, display it
                                                        ? userData?.FilePath // If it's a valid URL, display it
                                                        : `data:image/png;base64,${userData?.FilePath}` // If it's base64, prepend the MIME type
                                                    : customerImg // Fallback to customerImg if no selected image or server image
                                        }
                                        alt=""
                                        className="img-fluid rounded-circle"
                                        style={{ width: '100px', height: '100px' }}
                                        onClick={handleUploadClick}
                                    />
                                    <input type="file"
                                        hidden
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                    />
                                    <p className="mt-2">Upload Image</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className='user-profile-form-row'>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formFirstName">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="First Name"
                                        value={userData.FirstName}
                                        onChange={(e) => handleChange("FirstName", e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formMiddleName">
                                    <Form.Label>Middle Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Middle Name"
                                        value={userData.MiddleName}
                                        onChange={(e) => handleChange("MiddleName", e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Last Name"
                                        value={userData.LastName}
                                        onChange={(e) => handleChange("LastName", e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                        </Row>

                        <Row className='user-profile-form-row'>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formEmail">
                                    <Form.Label>Email ID</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Email ID"
                                        value={userData.EmailID}
                                        onChange={(e) => handleChange("EmailID", e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formContactNumber">
                                    <Form.Label>Contact Number</Form.Label>
                                    <div className='user-profile-contact-div'>
                                        <Select
                                            className="react-select-container mr-2"
                                            classNamePrefix="react-select"
                                            value={getCountryCodeDropdownData?.find(option => option.value === userData.CountryCodeID)}
                                            onChange={handleChangeCountryCode}
                                            options={getCountryCodeDropdownData}
                                            placeholder="Select"
                                        />
                                        <Form.Control
                                            type="tel"
                                            placeholder="Contact Number"
                                            value={userData.Phone}
                                            onChange={(e) => handleChange("Phone", e.target.value)}
                                            required
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formAddress">
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Address"
                                        value={userData?.WorkAddress}
                                        onChange={(e) => handleChange("WorkAddress", e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                        </Row>

                        <Row className='user-profile-form-row'>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formZipCode">
                                    <Form.Label>Zip Code</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Zip Code"
                                        value={userData.ZipCode}
                                        onChange={(e) => handleChange("ZipCode", e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <div className='add-customer-calendar-container'>
                                    <label>Date of Birth</label>
                                    {/* <div className='add-customer-calendar-container'> */}
                                    <DatePicker
                                        className="select from-date"
                                        id="date-range-picker"
                                        dateFormat="dd/MM/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        // selectsRange
                                        dropdownMode="select"
                                        placeholderText='DD/MM/YYYY'
                                        selected={userData.DOB ? moment(userData.DOB, 'DD-MM-YYYY').toDate() : null} // Convert string to Date object
                                        onChange={(date) => handleDateChange("DOB", date)}
                                        maxDate={new Date()}
                                    />
                                    <img src={calendar} alt="" />
                                    {/* </div> */}
                                </div>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formContactNumber">
                                    <Form.Label>Emergency Contact</Form.Label>
                                    <div className='user-profile-contact-div'>
                                        <Select
                                            className="react-select-container mr-2"
                                            classNamePrefix="react-select"
                                            options={getCountryCodeDropdownData}
                                            value={getCountryCodeDropdownData?.find(option => option.value === userData.SecondaryPhoneCountryCodeID)}
                                            onChange={handleChangeEmergencyCode}
                                            placeholder="select"
                                        />
                                        <Form.Control
                                            type="tel"
                                            placeholder="Emergency Contact"
                                            value={userData.SecondaryPhone}
                                            onChange={(e) => handleChange("SecondaryPhone", e.target.value)}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='user-profile-form-row'>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formRole">
                                    <Form.Label>Role</Form.Label>
                                    {/* <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={roleOptions}
                                        placeholder="Select"
                                    /> */}
                                    <Form.Control
                                        type="text"
                                        value={userData.AssignedRoles}
                                        onChange={(e) => handleChange("AssignedRoles", e.target.value)}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formDepartment">
                                    <Form.Label>Department</Form.Label>
                                    {/* <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select"
                                    /> */}
                                    <Form.Control
                                        type="text"
                                        value={userData.DepartmentName}
                                        onChange={(e) => handleChange("DepartmentName", e.target.value)}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formJobTitle">
                                    <Form.Label>Job Title</Form.Label>
                                    {/* <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select"
                                    /> */}
                                    <Form.Control
                                        type="text"
                                        value={userData.JobTitle}
                                        onChange={(e) => handleChange("JobTitle", e.target.value)}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='user-profile-form-row'>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formDateFormat">
                                    <Form.Label>Date Format</Form.Label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={dateFormatOptions}
                                        placeholder="Select"
                                        value={dateFormatOptions.find(option => option.value === userData.DateFormat)}
                                        onChange={(selectedOption) => handleChange("DateFormat", selectedOption.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formTimeFormat">
                                    <Form.Label>Time Format</Form.Label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={timeFormatOptions}
                                        placeholder="Select"
                                        value={timeFormatOptions.find(option => option.value === userData.TimeFormat)}
                                        onChange={(selectedOption) => handleChange("TimeFormat", selectedOption.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formTimeZone">
                                    <Form.Label>Time Zone</Form.Label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={getTimeZoneDropdown}
                                        placeholder="Select"
                                        value={getTimeZoneDropdown.find(option => option.value === userData.TimeZone)}
                                        onChange={(selectedOption) => handleChange("TimeZone", selectedOption.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='user-profile-form-row'>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formPassword">
                                    <Form.Label>Total Experience (Year)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={userData.TotalExperience}
                                        onChange={(e) => handleChange("TotalExperience", e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className='user-profile-form-col'>
                                <Form.Group controlId="formProfileVisibility">
                                    <Form.Label>Email Notifications</Form.Label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={emailNotificationOptions}
                                        placeholder="Select"
                                        value={emailNotificationOptions.find(option => option.value === (userData.IsToSendEmailNotifications ? 1 : 0))}
                                        onChange={(selectedOption) => handleChange("IsToSendEmailNotifications", selectedOption.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <div className='add-customer-calendar-container'>
                                    <label>Joining Date</label>
                                    {/* <div className='add-customer-calendar-container'> */}
                                    <DatePicker
                                        className="select from-date"
                                        id="date-range-picker"
                                        dateFormat="dd/MM/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        // selectsRange
                                        dropdownMode="select"
                                        placeholderText='DD/MM/YYYY'
                                        selected={userData.DOJ ? moment(userData.DOJ, 'DD-MM-YYYY').toDate() : null} // Convert string to Date object
                                        onChange={(date) => handleDateChange("DOJ", date)}
                                        maxDate={new Date()}
                                    />
                                    <img src={calendar} alt="" />
                                    {/* </div> */}
                                </div>
                            </Col>
                        </Row>
                        <Row className='user-profile-form-row mt-3 mb-4 p-4'>
                            <Col md={12} className="d-flex justify-content-center">
                                <SBSaveUpdateBtn btnName="Set Password" onClickEffect={handleOpenModal} />
                            </Col>
                        </Row>
                        {/* <Row className='user-profile-form-row'>
                        <Col md={4} className='user-profile-form-col'>
                            <Form.Group controlId="formProfileVisibility">
                                <Form.Label>Profile Visibility</Form.Label>
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={profileVisibilityOptions}
                                    placeholder="Select"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4} className='user-profile-form-col'>
                            <Form.Group controlId="formEmailNotifications">
                                <Form.Label>Email Notifications</Form.Label>
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={emailNotificationOptions}
                                    placeholder="Select"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4} className='user-profile-form-col'>
                            <Form.Group controlId="formPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" />
                            </Form.Group>
                        </Col>
                        <Col md={4} className='user-profile-form-col'>
                            <Form.Group controlId="formConfirmPassword">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control type="password" placeholder="Confirm Password" />
                            </Form.Group>
                        </Col>
                    </Row> */}
                        <hr />
                        <div className="user-profile-submit-btn">
                            <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddProfileData} />
                        </div>

                    </Col>

                </Row>
            </Main>
            {
                isModalOpen && <SetPasswordModal
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                />
            }
        </div>
    );
};

export default UserProfileForm;
